<script>
  import PDPFreescroll from '@/components/PDPFreescroll.vue';
  import { emitter } from '@/main.js';
  import storefront from '@/lib/storefront.js';
  import * as queries from '@/lib/queries.js';

  export default {
    name: 'OutfitPicker',
    components: {
      PDPFreescroll
    },
    data() {
      return {
        nonActiveImageOverlayColor: null,
        nonActiveImageOverlayOpacity: null,
        arrowCustomOn: false,
        arrowLeftImage: false,
        arrowLeftImageAlt: '',
        arrowLeftImageWidth: '',
        arrowLeftImageHeight: '',
        arrowLeftImageDisabled: false,
        arrowLeftImageDisabledAlt: '',
        arrowLeftImageDisabledWidth: '',
        arrowLeftImageDisabledHeight: '',
        collectionOne: [],
        collectionTwo: [],
        collectionList: [[], []],
        isOutfitPicker: false,
        mobileImageSpacing: 10,
        mobileNonActiveSlideWidth: 80,
        nonActiveSlideWidth: 80,
        outfitPickerMetafield: '',
        pdp_desktop_image_width: window.pdp_desktop_image_width,
        pdp_tablet_image_width: window.pdp_tablet_image_width,
        pdp_mobile_image_width: window.pdp_mobile_image_width,
        windowWidth: window.innerWidth,
        selectedProducts: {
          0: null,
          1: null
        },
        titleNodes: [],
        colorNameNodes: [],
        pdp_image_spacing: 5,
        pdp_image_bg_color: '',
        colorNameMonitors: []
      };
    },
    mounted() {
      this.nonActiveSlideWidth = this.$el.parentElement.dataset.nonActiveSlideWidth;
      this.nonActiveImageOverlayColor = this.$el.parentElement.dataset.nonActiveImageOverlayColor;
      this.nonActiveImageOverlayOpacity = this.$el.parentElement.dataset.nonActiveImageOverlayOpacity;
      this.mobileImageSpacing = this.$el.parentElement.dataset.mobileImageSpacing;
      this.mobileNonActiveSlideWidth = this.$el.parentElement.dataset.mobileNonActiveSlideWidth;
      this.arrowCustomOn = this.$el.parentElement.dataset.arrowCustomOn;
      this.arrowLeftImage = this.$el.parentElement.dataset.arrowLeftImage;
      this.arrowLeftImageAlt = this.$el.parentElement.dataset.arrowLeftImageAlt;
      this.arrowLeftImageWidth = this.$el.parentElement.dataset.arrowLeftImageWidth;
      this.arrowLeftImageHeight = this.$el.parentElement.dataset.arrowLeftImageHeight;
      this.arrowLeftImageDisabled = this.$el.parentElement.dataset.arrowLeftImageDisabled;
      this.outfitPickerMetafield = this.$el.parentElement.dataset.outfitPickerMetafield;
      this.collectionOneId = `gid://shopify/Collection/${this.$el.parentElement.dataset.collectionOne}`;
      this.collectionTwoId = `gid://shopify/Collection/${this.$el.parentElement.dataset.collectionTwo}`;
      this.itemsToShow = this.$el.parentElement.dataset.itemsToShow;
      this.itemsToShowMobile = this.$el.parentElement.dataset.itemsToShowMobile;
      this.arrowGap = this.$el.parentElement.dataset.arrowGap;

      const sectionRoot = this.$el.parentElement.closest('.product-section');
      if (sectionRoot) {
        const raw = getComputedStyle(sectionRoot).getPropertyValue('--IMAGE-SPACING');
        const parsed = parseFloat(String(raw).replace('px', '').trim());
        if (!Number.isNaN(parsed)) {
          this.pdp_image_spacing = parsed;
        }
        const bgRaw = getComputedStyle(sectionRoot).getPropertyValue('--IMAGE-BG-COLOR');
        const bg = String(bgRaw).trim();
        if (bg) this.pdp_image_bg_color = bg;
      }

      Promise.all([
        storefront.request(queries.getCollectionProductsWithMetafields, {
          variables: {
            namespace: this.outfitPickerMetafield.split('.').shift(),
            key: this.outfitPickerMetafield.split('.').pop(),
            id: this.collectionOneId
          }
        }),
        storefront.request(queries.getCollectionProductsWithMetafields, {
          variables: {
            namespace: this.outfitPickerMetafield.split('.').shift(),
            key: this.outfitPickerMetafield.split('.').pop(),
            id: this.collectionTwoId
          }
        })
      ])
        .then(([collectionOne, collectionTwo]) => {
          this.collectionOne = collectionOne.data.collection.products.edges.map(product => ({
            node: {
              ...product.node,
              image: {
                url: product.node.metafield?.reference?.image?.url || '',
                alt: product.node.metafield?.reference?.alt || product.node.metafield?.reference?.image?.altText || ''
              }
            }
          }));
          this.collectionTwo = collectionTwo.data.collection.products.edges.map(product => ({
            node: {
              ...product.node,
              image: {
                url: product.node.metafield?.reference?.image?.url || '',
                alt: product.node.metafield?.reference?.alt || product.node.metafield?.reference?.image?.altText || ''
              }
            }
          }));
        })
        .finally(() => {
          this.collectionList = [this.collectionOne, this.collectionTwo];
          this.selectedProducts[0] = this.collectionOne[0] || null;
          this.selectedProducts[1] = this.collectionTwo[0] || null;
          this.updateTitle(0);
          this.updateTitle(1);
          setTimeout(() => {
            this.updateColorName(0);
            this.updateColorName(1);
          }, 400);
          const firstCollection = this.collectionOne[0]?.node;
          if (firstCollection) {
            const firstColor = firstCollection.variants?.edges?.[0]?.node?.selectedOptions?.find(o => o.name?.toLowerCase() === 'color')?.value;
            emitter.emit('outfit-picker-product-changed', {
              blockIndex: 1,
              productTitle: firstCollection.title,
              productHandle: firstCollection.handle,
              productColor: firstColor
            });
          }
          const secondCollection = this.collectionTwo[0]?.node;
          if (secondCollection) {
            const secondColor = secondCollection.variants?.edges?.[0]?.node?.selectedOptions?.find(o => o.name?.toLowerCase() === 'color')?.value;
            emitter.emit('outfit-picker-product-changed', {
              blockIndex: 2,
              productTitle: secondCollection.title,
              productHandle: secondCollection.handle,
              productColor: secondColor
            });
          }
          if (firstCollection) this.syncQuickviewForProduct(1, firstCollection);
          if (secondCollection) this.syncQuickviewForProduct(2, secondCollection);
          this.syncAtcForCollectionIndex(0, 0);
          this.syncAtcForCollectionIndex(1, 0);

          emitter.on('outfit-picker-size-changed', ({ blockIndex, size }) => {
            const collectionIndex = (blockIndex || 1) - 1;
            this.updatePriceForSizeChange(collectionIndex, size);
            this.syncAtcForCollectionIndex(collectionIndex, 0);
            this.recalcOptionWidths();
          });

          emitter.on('outfit-picker-width-changed', ({ blockIndex, width }) => {
            const collectionIndex = (blockIndex || 1) - 1;
            this.updatePriceForWidthChange(collectionIndex, width);
            this.syncAtcForCollectionIndex(collectionIndex, 0);
            this.recalcOptionWidths();
          });
          this.recalcOptionWidths();
        })
        .catch(error => {
          console.error('Error fetching collection products', error);
        });

      this.titleNodes = Array.from(this.$el.parentElement.closest('.product-page')?.querySelectorAll('.product__title') || []);
      this.colorNameNodes = Array.from(this.$el.parentElement.closest('.product-page')?.querySelectorAll('.color-title .gt-p__small:last-of-type') || []);
    },
    computed: {
      isMobile() {
        return this.windowWidth < window.theme.sizes.medium;
      }
    },
    beforeUnmount() {
      if (this.colorNameMonitors) {
        this.colorNameMonitors.forEach(interval => {
          if (interval) clearInterval(interval);
        });
        this.colorNameMonitors = [];
      }
    },
    methods: {
      recalcOptionWidths() {
        const root = this.$el.parentElement.closest('.product-page');

        const sizeContainers = Array.from(root.querySelectorAll('.op-size-options'));
        sizeContainers.forEach(container => {
          const options = Array.from(container.querySelectorAll('.variant-spacing.option-size-2 .p-options'));
          options.forEach(o => {
            o.style.width = '';
          });
          let biggest = 0;
          options.forEach(o => {
            biggest = Math.max(biggest, o.offsetWidth || 0);
          });
          if (biggest > 0)
            options.forEach(o => {
              o.style.width = biggest + 'px';
            });
        });

        const widthContainers = Array.from(root.querySelectorAll('.op-width-options'));
        widthContainers.forEach(container => {
          const options = Array.from(container.querySelectorAll('.variant-spacing.option-size-3 .p-options'));
          options.forEach(o => {
            o.style.width = '';
          });
          let biggest = 0;
          options.forEach(o => {
            biggest = Math.max(biggest, o.offsetWidth || 0);
          });
          if (biggest > 0)
            options.forEach(o => {
              o.style.width = biggest + 'px';
            });
        });
      },
      syncTitle({ mountEl, title, handle }) {
        if (!mountEl) return;
        const titleNode = mountEl.querySelector('.js-dynamic-product-title') || mountEl.querySelector('.product__title');
        if (titleNode && title) {
          titleNode.textContent = title;
        }
        const anchor = mountEl.querySelector('a') || (titleNode && titleNode.closest('a'));
        if (anchor && handle) {
          anchor.href = `/products/${handle}`;
        }
      },
      syncProductTemplateLink(mountEl, handle) {
        if (!mountEl || !handle) return;
        const opProduct = mountEl.closest('.op-product');
        if (opProduct) {
          const linkInColumn = opProduct.querySelector('a.product-template-link');
          if (linkInColumn) {
            linkInColumn.href = `/products/${handle}`;
            return;
          }
        }
        let nextSibling = mountEl.closest('.op-title')?.nextElementSibling;
        while (nextSibling) {
          const directIsLink = nextSibling.matches && nextSibling.matches('a.product-template-link');
          const descendantLink = !directIsLink && nextSibling.querySelector ? nextSibling.querySelector('a.product-template-link') : null;
          const target = directIsLink ? nextSibling : descendantLink;
          if (target) {
            target.href = `/products/${handle}`;
            break;
          }
          nextSibling = nextSibling.nextElementSibling;
        }
      },
      onSlideChange(collectionIndex, payload) {
        this.selectedProducts[collectionIndex] = payload && payload.product ? payload.product : null;
        this.updateTitle(collectionIndex);
        this.updateColorName(collectionIndex);
        this.syncAtcForCollectionIndex(collectionIndex, payload?.index || 0);
        const raw = this.selectedProducts[collectionIndex]?.node || this.collectionList[collectionIndex]?.[payload?.index || 0]?.node || null;
        if (raw) {
          const productColor = raw.variants?.edges?.[0]?.node?.selectedOptions?.find(o => o.name?.toLowerCase() === 'color')?.value;
          emitter.emit('outfit-picker-product-changed', {
            blockIndex: collectionIndex + 1,
            productTitle: raw.title || '',
            productHandle: raw.handle || '',
            productColor: productColor
          });
          this.syncQuickviewForProduct(collectionIndex + 1, raw);
        }
        this.recalcOptionWidths();
      },
      syncAtcForCollectionIndex(collectionIndex, slideIndex) {
        const rawCollection = this.collectionList[collectionIndex];

        const mapped = this.selectedProducts[collectionIndex];
        let rawProduct = null;
        if (mapped && mapped.node) {
          rawProduct = mapped.node;
        }
        if (!rawProduct) {
          rawProduct = rawCollection[slideIndex]?.node || rawCollection[0]?.node || null;
        }
        if (!rawProduct) return;

        const variants = (rawProduct.variants?.edges || []).map(e => e.node);
        const { selectedColor, selectedSize, selectedWidth } = this.getSelectedOptionsForSide(collectionIndex);
        const activeVariant = this.pickVariantForOptions(variants, selectedColor, selectedSize, selectedWidth) || variants[0] || null;
        if (!activeVariant) return;
        const variantPrice = Number(activeVariant.price?.amount) || 0;
        const comparePrice = Number(activeVariant.compareAtPrice?.amount) || 0;

        try {
          const inner = this.$el.parentElement.closest('.product-page')?.querySelector('.product__main__content .product__inner');
          if (inner) {
            const numericProductId = String(rawProduct.id || '').replace(/\D+/g, '');
            const atcNodes = inner.querySelectorAll('.op-atc .PDPaddToCart');
            let targetAtc = null;
            if (atcNodes && atcNodes.length) {
              targetAtc = Array.from(atcNodes).find(n => Number(n.getAttribute('data-outfit-picker-index')) === collectionIndex + 1) || atcNodes[collectionIndex] || atcNodes[0];
            }
            if (targetAtc) {
              if (numericProductId) targetAtc.setAttribute('data-product-id', numericProductId);
              if (rawProduct.handle) targetAtc.setAttribute('data-product-handle', rawProduct.handle);
              targetAtc.setAttribute('data-is-outfit-picker', 'true');
              targetAtc.setAttribute('data-outfit-picker-index', String(collectionIndex + 1));
            }
            const stickyNodes = document.querySelectorAll('#sticky-PDPaddtocart');
            const targetSticky = stickyNodes[collectionIndex] || stickyNodes[0];
            if (targetSticky) {
              if (numericProductId) targetSticky.setAttribute('data-product-id', numericProductId);
              if (rawProduct.handle) targetSticky.setAttribute('data-product-handle', rawProduct.handle);
              targetSticky.setAttribute('data-is-outfit-picker', 'true');
              targetSticky.setAttribute('data-outfit-picker-index', String(collectionIndex + 1));
            }
          }
        } catch (e) {
          console.error('Failed to sync outfit picker metadata', e);
        }

        this.emitPriceAndAtc(collectionIndex, rawProduct, activeVariant, variantPrice, comparePrice, collectionIndex + 1);
      },
      updateTitle(collectionIndex) {
        const mount = this.titleNodes[collectionIndex]?.closest('.product__title__wrapper');
        const product = this.selectedProducts[collectionIndex];
        const titleText = product && product.node && product.node.title ? product.node.title : '';
        const handle = product && product.node && product.node.handle ? product.node.handle : '';
        if (!mount || !titleText) return;
        this.syncTitle({ mountEl: mount, title: titleText, handle });
        this.syncProductTemplateLink(mount, handle);
      },
      updateColorName(collectionIndex) {
        const colorNameNode = Array.from(this.$el.parentElement.closest('.product-page')?.querySelectorAll('.color-title .gt-p__small:last-of-type'))?.[collectionIndex];
        if (!colorNameNode) return;

        const selectedProduct = this.selectedProducts[collectionIndex]?.node;
        if (!selectedProduct) return;

        const firstVariantColor = selectedProduct?.variants?.edges?.[0]?.node?.selectedOptions?.find(o => o.name?.toLowerCase() === 'color')?.value;

        if (!firstVariantColor) return;

        if (this.colorNameMonitors && this.colorNameMonitors[collectionIndex]) {
          clearInterval(this.colorNameMonitors[collectionIndex]);
        }

        colorNameNode.textContent = firstVariantColor;

        const monitorInterval = setInterval(() => {
          const node = Array.from(this.$el.parentElement.closest('.product-page')?.querySelectorAll('.color-title .gt-p__small:last-of-type'))?.[collectionIndex];
          if (!node) return;

          const currentProduct = this.selectedProducts[collectionIndex]?.node;
          if (!currentProduct) return;

          const expectedColor = currentProduct?.variants?.edges?.[0]?.node?.selectedOptions?.find(o => o.name?.toLowerCase() === 'color')?.value;
          if (!expectedColor) return;

          const currentColor = node.textContent?.trim();
          if (currentColor && currentColor !== expectedColor) {
            node.textContent = expectedColor;
          }
        }, 100);

        if (!this.colorNameMonitors) {
          this.colorNameMonitors = [];
        }
        this.colorNameMonitors[collectionIndex] = monitorInterval;
      },
      updatePriceForSizeChange(collectionIndex, size) {
        const rawCollection = this.collectionList[collectionIndex] || [];
        const mapped = this.selectedProducts[collectionIndex];
        const rawProduct = mapped?.node || rawCollection[0]?.node;
        if (!rawProduct) return;

        const variants = rawProduct.variants?.edges?.map(e => e.node) || [];
        if (!variants.length) return;

        const { selectedColor, selectedWidth } = this.getSelectedOptionsForSide(collectionIndex);

        const hasVal = (v, val) => v?.selectedOptions?.some(o => o.value === val);

        let match = null;
        if (size) {
          match = variants.find(v => hasVal(v, size) && (!selectedWidth || hasVal(v, selectedWidth)) && (!selectedColor || hasVal(v, selectedColor)));
          if (!match) {
            match = variants.find(v => hasVal(v, size) && (!selectedWidth || hasVal(v, selectedWidth)));
          }
          if (!match && selectedColor) {
            match = variants.find(v => hasVal(v, size) && hasVal(v, selectedColor));
          }
          if (!match) {
            match = variants.find(v => hasVal(v, size));
          }
        }
        if (!match) match = variants[0];
        if (!match) return;
        const variantPrice = Number(match.price?.amount) || 0;
        const comparePrice = Number(match.compareAtPrice?.amount) || 0;
        this.emitPriceAndAtc(collectionIndex, rawProduct, match, variantPrice, comparePrice, collectionIndex + 1);
      },
      updatePriceForWidthChange(collectionIndex, width) {
        const rawCollection = this.collectionList[collectionIndex] || [];
        const mapped = this.selectedProducts[collectionIndex];
        const rawProduct = mapped?.node || rawCollection[0]?.node;
        if (!rawProduct) return;

        const variants = rawProduct.variants?.edges?.map(e => e.node) || [];
        if (!variants.length) return;

        const { selectedColor, selectedSize } = this.getSelectedOptionsForSide(collectionIndex);

        const hasVal = (v, val) => v?.selectedOptions?.some(o => o.value === val);

        let match = null;
        if (width) {
          match = variants.find(v => hasVal(v, width) && (!selectedSize || hasVal(v, selectedSize)) && (!selectedColor || hasVal(v, selectedColor)));
          if (!match && selectedSize) {
            match = variants.find(v => hasVal(v, width) && hasVal(v, selectedSize));
          }
          if (!match && selectedColor) {
            match = variants.find(v => hasVal(v, width) && hasVal(v, selectedColor));
          }
          if (!match) {
            match = variants.find(v => hasVal(v, width));
          }
        }
        if (!match) match = variants[0];
        if (!match) return;
        const variantPrice = Number(match.price?.amount) || 0;
        const comparePrice = Number(match.compareAtPrice?.amount) || 0;
        this.emitPriceAndAtc(collectionIndex, rawProduct, match, variantPrice, comparePrice, collectionIndex + 1);
      },
      syncQuickviewForProduct(blockIndex, productNode) {
        try {
          if (!blockIndex || !productNode) return;
          const handle = productNode.handle || '';
          const mediaGid = productNode.featuredMedia?.id || productNode.featuredImage?.id || '';
          const mediaIdNumeric = mediaGid ? String(mediaGid).split('/').pop() : '';
          const selector = `product-quickview[data-is-outfit-picker="true"][data-outfit-picker-index="${blockIndex}"]`;
          const qv = this.$el.closest('.product-page')?.querySelector(selector);
          if (!qv) return;
          const holder = qv.querySelector('[data-quickview-holder]');
          if (!holder) return;
          const modalId = holder.getAttribute('data-quickview-holder');
          if (!modalId) return;
          const trigger = holder.querySelector(`[data-popup-${modalId}]`);
          if (trigger) {
            if (handle) trigger.setAttribute(`data-popup-${modalId}`, handle);
            if (mediaIdNumeric) trigger.setAttribute('data-media-select', mediaIdNumeric);
          }
          if (handle) qv.handle = handle;
        } catch (e) {
          console.error('Error syncing quickview handle', e);
        }
      },
      getSelectedOptionsForSide(collectionIndex) {
        let selectedColor = '';
        let selectedSize = '';
        let selectedWidth = '';
        try {
          const root = this.$el.parentElement.closest('.product-page');
          const inner = root ? root.querySelector('.product__main__content .product__inner') : null;
          if (inner) {
            const colorContainers = inner.querySelectorAll('.op-color-options');
            const sizeContainers = inner.querySelectorAll('.op-size-options');
            const widthContainers = inner.querySelectorAll('.op-width-options');

            const colorScope = colorContainers[collectionIndex] || inner;
            const sizeScope = sizeContainers[collectionIndex] || inner;
            const widthScope = widthContainers[collectionIndex] || inner;

            const colorEl = colorScope.querySelector('.color-variant-options [data-color].selected');
            if (colorEl) selectedColor = colorEl.getAttribute('data-color') || '';

            const sizeEl = sizeScope.querySelector('.size-variant-options [data-size].selected');
            if (sizeEl) {
              const raw = sizeEl.getAttribute('data-size') || '';
              selectedSize = raw.startsWith('s') ? raw.slice(1) : raw;
            }

            const widthEl = widthScope.querySelector('.width-variant-options [data-width].selected');
            if (widthEl) {
              const rawW = widthEl.getAttribute('data-width') || '';
              selectedWidth = rawW.startsWith('w') ? rawW.slice(1) : rawW;
            }
          }
        } catch (e) {
          console.error('Failed to read selected options for outfit picker', e);
        }
        return { selectedColor, selectedSize, selectedWidth };
      },
      pickVariantForOptions(variants, selectedColor, selectedSize, selectedWidth) {
        const hasVal = (v, val) => v?.selectedOptions?.some(o => o.value === val);
        let match = null;
        if (selectedColor || selectedSize || selectedWidth) {
          match = variants.find(v => (!selectedColor || hasVal(v, selectedColor)) && (!selectedSize || hasVal(v, selectedSize)) && (!selectedWidth || hasVal(v, selectedWidth)));
        }
        if (!match && selectedWidth && selectedSize) match = variants.find(v => hasVal(v, selectedWidth) && hasVal(v, selectedSize));
        if (!match && selectedWidth && selectedColor) match = variants.find(v => hasVal(v, selectedWidth) && hasVal(v, selectedColor));
        if (!match && selectedSize && selectedColor) match = variants.find(v => hasVal(v, selectedSize) && hasVal(v, selectedColor));
        if (!match && selectedWidth) match = variants.find(v => hasVal(v, selectedWidth));
        if (!match && selectedSize) match = variants.find(v => hasVal(v, selectedSize));
        if (!match && selectedColor) match = variants.find(v => hasVal(v, selectedColor));
        return match || null;
      },
      emitPriceAndAtc(collectionIndex, rawProduct, variant, variantPrice, comparePrice, blockIndex) {
        emitter.emit('updatePriceBlock', {
          blockIndex: blockIndex,
          variantPrice,
          comparePrice,
          isOutfitPicker: true
        });
        try {
          const numericVariantId = String(variant.id || '')
            .split('/')
            .pop();
          const { selectedColor, selectedSize, selectedWidth } = this.getSelectedOptionsForSide(collectionIndex);
          const hasSpecificSelection = !!selectedColor || !!selectedSize || !!selectedWidth;
          const variantMatchesSelection =
            !!variant?.selectedOptions &&
            (!selectedColor || variant.selectedOptions.some(o => o.value === selectedColor)) &&
            (!selectedSize || variant.selectedOptions.some(o => o.value === selectedSize)) &&
            (!selectedWidth || variant.selectedOptions.some(o => o.value === selectedWidth));
          let instock = !!variant.availableForSale;
          let notavail = !instock;
          if (hasSpecificSelection && !variantMatchesSelection) {
            instock = false;
            notavail = true;
          }
          emitter.emit('updateAddButton', {
            variantId: numericVariantId,
            parentId: rawProduct.id,
            handle: rawProduct.handle,
            variantPrice: variantPrice,
            comparePrice: comparePrice,
            instock,
            notavail,
            isOutfitPicker: true,
            blockIndex: blockIndex,
            collectionIndex
          });
        } catch (e) {
          console.error('Failed to emit outfit picker add-to-cart event', e);
        }
      }
    }
  };
</script>

<template>
  <section class="outfit-picker-wrapper">
    <PDPFreescroll v-for="(collection, index) in collectionList" :nonActiveImageOverlayColor="nonActiveImageOverlayColor" :nonActiveImageOverlayOpacity="nonActiveImageOverlayOpacity" :arrowGap="arrowGap" :arrowLeftImage="arrowLeftImage" :arrowLeftImageAlt="arrowLeftImageAlt" :arrowLeftImageWidth="arrowLeftImageWidth" :arrowLeftImageHeight="arrowLeftImageHeight" :arrowLeftImageDisabled="arrowLeftImageDisabled" :arrowLeftImageDisabledAlt="arrowLeftImageDisabledAlt" :arrowLeftImageDisabledWidth="arrowLeftImageDisabledWidth" :arrowLeftImageDisabledHeight="arrowLeftImageDisabledHeight" :isMobile="isMobile" :isOutfitPicker="true" :itemsToShow="itemsToShow" :itemsToShowMobile="itemsToShowMobile" :key="index" :index="index" :media="collection" :desktopImageWidth="pdp_desktop_image_width" :mobileImageWidth="pdp_mobile_image_width" :tabletImageWidth="pdp_tablet_image_width" :imagePadding="pdp_image_spacing" :mobileImageSpacing="mobileImageSpacing" :mobileNonActiveSlideWidth="mobileNonActiveSlideWidth" :showArrows="true" :useCustomArrows="arrowCustomOn" :imageBackgroundColor="pdp_image_bg_color" :nonActiveSlideWidth="nonActiveSlideWidth" @slide-change="onSlideChange(index, $event)"></PDPFreescroll>
  </section>
</template>
